<section id="secao-banner" class="p-0">
  <div class="container-video">
    <div class="overlay"></div>

    <video class="video" autoplay muted loop>
      <source src="assets/video/banner.mp4" type="video/mp4" />
    </video>
    <div class="descricao">
      <h1>
        Iniciação tecnológica,<br />
        incubação de empresas, aceleração de negócios
      </h1>
      <hr/>
      <p>
        A Fundação Educere é uma incubadora de empresas de base tecnológica
        diferenciada pelo ambiente e networking colaborativo.
      </p>
    </div>
  </div>
</section>
